import React from 'react'
import { toast } from 'react-toastify'
import { t } from 'ttag'
import './ToastNotifications.css'

interface IToastContent {
    message: string
}

const NotificationSentToastContent: React.FC<IToastContent> = ({ message }) => (
    <div className="notification-sent-toast-content">
        <i className="fas fa-envelope envelope-icon" />
        <span className="toast-message">{message}</span>
    </div>
)

/**
 * Shows a toast notification with an envelope icon followed by a green checkmark icon.
 * The toast appears for 5 seconds and then automatically closes.
 * 
 * @param message - The message to display in the toast
 * @returns The toast ID that can be used to dismiss the toast manually if needed
 */
export function showNotificationSentToast(message: string = '') {
        return toast.success(
            <NotificationSentToastContent message={message} />,
            {
                autoClose: 3000, // 3 seconds
                position: toast.POSITION.TOP_LEFT,
                className: 'notification-sent-toast no-transparency',
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            }
        )
}

export default showNotificationSentToast
